import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";


// Firebase Configurations for different projects
const firebaseConfigs = {
    admin: {
        apiKey: "AIzaSyB5htBstObXmLn7HKdT9oNiPgDGwQ7zwJE",
        authDomain: "etikaf-admin.firebaseapp.com",
        projectId: "etikaf-admin",
        storageBucket: "etikaf-admin.appspot.com",
        messagingSenderId: "210475893981",
        appId: "1:210475893981:web:6b1368a6579a38872fc734",
        measurementId: "G-R1DDERWF98"
    },
    ustaz: {
        apiKey: "AIzaSyCiL16E6jRvlIF4HKaD6Jp-EgxXl6f10ns",
        authDomain: "asatizah-etikaf.firebaseapp.com",
        projectId: "asatizah-etikaf",
        storageBucket: "asatizah-etikaf.firebasestorage.app",
        messagingSenderId: "229047628728",
        appId: "1:229047628728:web:408e233883270a916b954d",
        measurementId: "G-Q21GH77FLD"
    },
    web: {
        apiKey: "AIzaSyApJNS5RuicEhRWUcV86H0uoov6uYeI6Tc",
        authDomain: "etikaf-web.firebaseapp.com",
        projectId: "etikaf-web",
        storageBucket: "etikaf-web.firebasestorage.app",
        messagingSenderId: "1049695224012",
        appId: "1:1049695224012:web:17544b1408ac322b2a8269",
        measurementId: "G-1GXE3EE055"
    },
};

/* =========================================================
   Get / init Firebase App by name
========================================================= */
const getFirebaseApp = (name) => {
    const cfg = firebaseConfigs?.[name];
    if (!cfg) throw new Error(`Firebase config not found for app: ${name}`);

    if (!getApps().some((app) => app.name === name)) {
        return initializeApp(cfg, name);
    }
    return getApp(name);
};

/* =========================================================
   Apps
========================================================= */
const adminApp = getFirebaseApp("admin");
const ustazApp = getFirebaseApp("ustaz");
const webApp = getFirebaseApp("web");

/* =========================================================
   Firestore
========================================================= */
const dbAdmin = getFirestore(adminApp);
const dbUstaz = getFirestore(ustazApp);
const dbWeb = getFirestore(webApp);

/* =========================================================
   Storage (biasanya Kerjaya perlukan yang WEB)
========================================================= */
const storageWeb = getStorage(webApp);
const authWeb = getAuth(webApp);
const functionsWeb = getFunctions(webApp, "us-central1");

const appCheckSiteKey = process.env.REACT_APP_FIREBASE_APP_CHECK_SITE_KEY;
const appCheckWeb =
    typeof window !== "undefined" && appCheckSiteKey
        ? initializeAppCheck(webApp, {
            provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
            isTokenAutoRefreshEnabled: true,
        })
        : null;

/* =========================================================
   Analytics (WEB sahaja) — selamat untuk SSR / build
========================================================= */
const analyticsWebPromise =
    typeof window === "undefined"
        ? Promise.resolve(null)
        : isSupported().then((yes) => (yes ? getAnalytics(webApp) : null));

export {
    // helper (kalau komponen lain perlukan)
    getFirebaseApp,

    // apps
    adminApp,
    ustazApp,
    webApp,

    // firestore
    dbAdmin,
    dbUstaz,
    dbWeb,

    // storage
    storageWeb,

    // auth, callable functions & abuse protection (WEB sahaja)
    authWeb,
    functionsWeb,
    appCheckWeb,

    // analytics
    analyticsWebPromise,
};
